import { ComponentPropsWithoutRef } from 'react';

import { CoreInput, CoreInputProps } from './components/CoreInput';

export interface InputProps extends CoreInputProps, ComponentPropsWithoutRef<'input'> {}

export const Input = (props: InputProps) => {
    return <CoreInput {...props} />;
};
